import React from 'react';
import ReactDOM from 'react-dom/client';  // Opravený import
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/index.css';
import App from './App';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';

// Vytvoření historie
const browserHistory = createBrowserHistory();

// MSAL initialization
const msalInstance = new PublicClientApplication(msalConfig);

// Application Insights initialization
const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
    config: {
        instrumentationKey: '01ca7643-0056-4484-9a16-659ee0f27398',
        extensions: [reactPlugin],
        extensionConfig: {
            [reactPlugin.identifier]: { 
                history: browserHistory
            }
        },
        enableAutoRouteTracking: true,
        enableCorsCorrelation: true,
        enableRequestHeaderTracking: true,
        enableResponseHeaderTracking: true
    }
});

// Start Application Insights
appInsights.loadAppInsights();

// Export pro použití v jiných komponentách
export const appInsightsInstance = appInsights;

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <MsalProvider instance={msalInstance}>
            <App />
        </MsalProvider>
    </React.StrictMode>
);